import { actionCreator, createApiActions, createRequestTypes } from 'Redux/actions'

export const LISTING_ALERT_TYPE = 'ListingAlert'
export const BUILDING_ALERT_TYPE = 'BuildingAlert'
export const RECOMMENDATION_ALERT_TYPE = 'RecommendationAlert'

export const CREATE_ALERT = 'CREATE_ALERT'
export const createAlert = ({ payload }) => actionCreator(CREATE_ALERT, { payload })


export const LOAD_ALERTS = 'LOAD_ALERTS'
export const loadAlerts = ({ payload, forceFetch = false }) => actionCreator(LOAD_ALERTS, { payload, forceFetch })

export const LOAD_RECOMMENDATION_ALERTS = 'LOAD_RECOMMENDATION_ALERTS'
export const loadRecommendationAlert = ({ payload }) =>
  actionCreator(LOAD_RECOMMENDATION_ALERTS, { payload })

export const UPDATE_ALERT = 'UPDATE_ALERT'
export const updateAlert = ({ id, payload, onSuccess }) => actionCreator(UPDATE_ALERT, { id, payload, onSuccess })

export const DELETE_ALERT = 'DELETE_ALERT'
export const deleteAlert = ({ id, alertType }) => actionCreator(DELETE_ALERT, { id, alertType })

export const TURN_OFF_ALL_ALERTS = 'TURN_OFF_ALL_ALERTS'
export const turnOffAllAlerts = (payload) => actionCreator(TURN_OFF_ALL_ALERTS, payload)

export const API_TURN_OFF_ALL_ALERTS = createRequestTypes('API_TURN_OFF_ALL_ALERTS')
export const apiTurnOffAllAlertsActions = createApiActions(API_TURN_OFF_ALL_ALERTS)


export const RESET_ALERTS = 'RESET_ALERTS'
export const resetAlerts = () => actionCreator(RESET_ALERTS)

export const LOAD_LEAD_PROFILE = 'LOAD_LEAD_PROFILE'
export const loadLeadProfile = ({ leadId }) => actionCreator(LOAD_LEAD_PROFILE, { leadId })

export const FETCH_LEAD_PROFILE_API = createRequestTypes('FETCH_LEAD_PROFILE_API')
export const fetchLeadProfileApiActions = createApiActions(FETCH_LEAD_PROFILE_API)
